import { BaseModel } from "../../base.model";

export class OperationsModel extends BaseModel {
    name?: string;
    description?: string; 
    parentId?: string;
    children?: OperationsModel[];
    isChecked?: boolean;
}
